
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class InvoiceObjectionSearchRequestModel extends Model<InvoiceObjectionSearchRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'commentFilter', type: 'string', languageString: 'invoiceObjectionSearchRequest.property.commentFilter' },
		{ name: 'onlyOpenInvoices', type: 'boolean', languageString: 'invoiceObjectionSearchRequest.property.onlyOpenInvoices' },
		{ name: 'reasonFilter', type: 'guid', languageString: 'invoiceObjectionSearchRequest.property.reasonFilter' }
	];
	[key: string]: any;
	
	public commentFilter: string;
	public onlyOpenInvoices: boolean;
	public reasonFilter?: string;
    
	constructor(){
		super();
		this.commentFilter = '';
		this.onlyOpenInvoices = false;
		this.reasonFilter = undefined;
		
	}
	getProperties(){
		return InvoiceObjectionSearchRequestModel.classProperties;
	}
}

